import { BroadcastAudienceType, BroadcastStatus, BroadcastType } from '@trnsact/trnsact-shared-types';

export const broadcastStatusBgColors: Record<BroadcastStatus, string> = {
  [BroadcastStatus.Draft]: '#FFE897',
  [BroadcastStatus.Published]: '#D3F2BD',
};

export const broadcastChipSettingsByType: Record<BroadcastType, { bgColor: string; label: string }> = {
  [BroadcastType.Product]: {
    bgColor: '#E8F1FC',
    label: 'Product Update',
  },
  [BroadcastType.Program]: {
    bgColor: '#F0ECF8',
    label: 'Program Update',
  },
  [BroadcastType.Compliance]: {
    bgColor: '#EAF3EF',
    label: 'Compliance Update',
  },
  [BroadcastType.Company]: {
    bgColor: '#FBF2E5',
    label: 'Company News',
  },
  [BroadcastType.Promotion]: {
    bgColor: '#FCEFE9',
    label: 'Promotion',
  },
  [BroadcastType.System]: {
    bgColor: '#efa9a9ff',
    label: 'System Notification',
  },
};

export const audienceTypeOptions = [
  { label: 'All Users', value: BroadcastAudienceType.AllUsers },
  { label: 'All Dealer Users', value: BroadcastAudienceType.Dealers },
  { label: 'All Lender Users', value: BroadcastAudienceType.Lenders },
  { label: 'All Partner Users', value: BroadcastAudienceType.AftermarketPartners },
];
